import { H3KR } from 'global-styles';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import acImg from 'public/asset/about/04-banner/banner@2x.png';
import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import Image from 'next/image';
import { MainButton } from 'global-styles/MainButton';
import { GoToIcon } from 'assets/icons';
import { generateCssStyle, mediaQueryStyle } from 'styles/breakPoints';

export const AboutCareer = () => {
  const { locale } = useRouter();

  if (locale === 'en') return null;

  return (
    <AboutCareerContainer>
      <div className="ac-inner-container">
        <ImgBackgroundWrapper>
          <Image
            src={acImg.src}
            layout="fill"
            alt="About bluedot"
            className="target-img"
            objectFit="cover"
            sizes="(min-width: 906px) 90vw,
                 (min-width: 600px) 88vw,
                 (max-width: 599px) 80vw"
            quality={70}
          />
        </ImgBackgroundWrapper>

        <AboutCareerH3KR>
          <span>블루닷과 함께 성장해 나갈</span>
          <span>열정 가득한 인재를 찾고 있습니다.</span>
        </AboutCareerH3KR>

        <MainButton
          injectInlineStyles={{ width: '328px' }}
          injectCssStyles={[
            generateCssStyle({ 'margin-top': '32px', height: '48px' }),
            mediaQueryStyle.M`margin-top:56px; height: 56px;`,
          ]}
          icon={<GoToIcon />}
          tag="a"
          href="https://blue-dot.career.greetinghr.com/"
          buttonType="default-w"
          changeIconColor
          target="_blank"
          iconPosition="right"
          text="채용페이지 바로가기"
        />
      </div>
    </AboutCareerContainer>
  );
};

const AboutCareerContainer = styled.section`
  width: 100vw;
  height: 744px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  @media screen and (min-width: 1440px) {
    width: 100%;
    max-width: 1200px;
    padding: 0 96px;
  }
  @media screen and (min-width: 1240px) and (max-width: 1439px) {
    width: 100%;
    padding: 0 96px;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    width: 100%;
    padding: 0 56px;
  }
  @media screen and (min-width: 600px) and (max-width: 904px) {
    width: 100%;
    padding: 0;
  }
  @media screen and (max-width: 599px) {
    width: 100%;
    padding: 0;
  }
  @media screen and (max-width: 1239px) {
    height: 652px;
  }

  .ac-inner-container {
    position: relative;
    height: 360px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    overflow: hidden;
  }
  @media screen and (max-width: 904px) {
    height: fit-content;
    .ac-inner-container {
      border-radius: 0;
    }
  }
`;

const AboutCareerH3KR = styled(H3KR)`
  color: #fff;
  text-align: center;
  span {
    display: block;
  }
`;
